<template>
    <div class="alert alert-dismissible fade show alert-olf-green" role="alert">
        {{actionConfirmationMessage}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="closeBubble()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    computed: {
        ...mapState('notifications', ['actionConfirmationMessage'])
    },
    methods: {
        ...mapActions('notifications', ['displayActionConfirmation']),
        closeBubble: function(){
            $('.alert-dismissible').alert('close')
            setTimeout(() => {
                this.displayActionConfirmation(false)
            }, 500)
        },
    }
}
</script>

<style lang="scss" scoped>
.alert-olf-green {
    font-weight: 700;
}
</style>
